import { render, staticRenderFns } from "./ListMenu.vue?vue&type=template&id=96e9cffe"
import script from "./ListMenu.vue?vue&type=script&lang=js"
export * from "./ListMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports